import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios } from "../../../../services/axios";

export const getChargesTypes = createAsyncThunk(
  "charges/getChargesTypes",
  async (args, thunkApi) => {
    try {
      const { data } = await axios.get("/Manage/Charge/LookUpChargeType");
      return thunkApi.fulfillWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e.response.data);
    }
  }
);